import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Construction } from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

interface PlaceholderPageProps {
    title: string;
    description?: string;
}

const PlaceholderPage = ({ title, description = "This page is under construction." }: PlaceholderPageProps) => {
    const { theme } = useTheme();
    
    return (
        <Box sx={{ p: 3 }}>
            <Paper sx={{ 
                bgcolor: theme.palette.background.paper, 
                border: `1px solid ${theme.palette.divider}`,
                p: 4,
                textAlign: 'center'
            }}>
                <Construction sx={{ fontSize: 64, color: 'secondary.main', mb: 2 }} />
                <Typography variant="h4" sx={{ color: theme.palette.text.primary, fontWeight: 600, mb: 2 }}>
                    {title}
                </Typography>
                <Typography variant="body1" sx={{ color: theme.palette.text.secondary }}>
                    {description}
                </Typography>
            </Paper>
        </Box>
    );
};

export default PlaceholderPage; 